import React, { useState, useEffect } from "react";
import { Sugestions } from "./_Sugestions";

export function Companies({ companies, selectedCompany, setSelectedCompany, companiesIptValue, setCompaniesIptValue }) {
    const [theCompanies, setCompanies] = useState([]);
console.log(companies)
    function filterSectors(term) {
        setCompanies(
            companies
                .filter((category) => {
                    return category.name.toLowerCase().indexOf(term.toLowerCase() || "ZERO COMPANIES, OK?") !== -1;
                })
                .slice(0, 4)
        );
        setCompaniesIptValue(term);
    }

    useEffect(() => {
        if (companiesIptValue === "") {
            setCompanies([]);
        }
    }, [companiesIptValue]);

    return (
        <React.StrictMode>
            <fieldset className="companies">
                <span className="title">
                    <i className="icon"></i>
                    {companiesTxt}
                </span>
                <input value={companiesIptValue} type="search" id="searchCompany" placeholder={findCompaniesTxt} onChange={(e) => filterSectors(e.target.value)} />
                <Sugestions categories={theCompanies} selectedCategory={selectedCompany} setSelectedCategory={setSelectedCompany} />
            </fieldset>
        </React.StrictMode>
    );
}
